import { Divider, FormLabel, Grid, GridItem, Input } from "@chakra-ui/react";
import AutocompleteInput from "../../inputs/AutocompleteInput";
import LimitedInput from "../../inputs/LimitedInput";
import { useIntl } from "react-intl";
import { useState } from "react";
import FormInput from "../../inputs/FormInput";

export default function BusinessForm({
  locale,
  purchaseCountry,
  setPurchaseCountry,
  purchaseShop,
  setPurchaseShop,
}) {
  const [companyDetails, setCompanyDetails] = useState({
    address1: "",
    address2: "",
    address3: "",
    postalCode: "",
    city: "",
    email: "",
    phone: "",
  });

  const { sav_form } = useIntl().messages;
  const [isInvalid, setIsInvalid] = useState(false);

  return (
    <>
      <Grid
        templateColumns={{
          sm: "repeat(2, 1fr)",
        }}
        gap={5}
        mt={5}
        width="100%"
      >
        <GridItem colSpan={2}>
          <AutocompleteInput
            name="purchaseCountry"
            label={sav_form.store.country.label}
            placeholder={sav_form.store.country.placeholder}
            apiIndex={`pays_${locale}`}
            selectedItem={purchaseCountry}
            setSelectedItem={setPurchaseCountry}
            itemLabel={(item) => item.name}
            fetchParams={{
              attributesToSearchOn: ["name"],
            }}
            isRequired={true}
          />
        </GridItem>

        {purchaseCountry && (
          <GridItem colSpan={2}>
            <AutocompleteInput
              name={"companyName"}
              label={sav_form.store.company_name.label}
              placeholder={sav_form.store.company_name.placeholder}
              apiIndex={"boutiques"}
              selectedItem={purchaseShop}
              setSelectedItem={(item) => {
                setPurchaseShop(item);
                if (item) setIsInvalid(false);
              }}
              itemLabel={(item) => `${item.RAISON_SOCIALE} - ${item.VILLE}`}
              itemValue={(item) => item.RAISON_SOCIALE}
              fetchParams={{
                attributesToSearchOn: ["RAISON_SOCIALE", "VILLE"],
                filter: `CODE_PAYS = ${purchaseCountry.alpha2code}`,
                limit: 200,
              }}
              isInvalid={isInvalid}
              isRequired={true}
              errorText={sav_form.company_name_error}
              pattern="^(.+) - (.+)$"
              onBlur={() => {
                if (!purchaseShop) {
                  setIsInvalid(true);
                }
              }}
            />
          </GridItem>
        )}

        {purchaseShop && (
          <>
            <GridItem colSpan={2}>
              <FormLabel htmlFor="codeClient">{sav_form.client_code}</FormLabel>
              <Input
                id="codeClient"
                type="text"
                name="codeClient"
                value={purchaseShop.CODE_CLIENT}
                readOnly
              />
            </GridItem>
            <input type="hidden" name="socCode" value={purchaseShop.CODE_SOC} />
            <input
              type="hidden"
              name="currency"
              value={purchaseShop.CODE_MON}
            />
          </>
        )}
        
        {!purchaseShop && (
          <input type="hidden" name="codeClient" value="" />
        )}

        <GridItem colSpan={2}>
          <LimitedInput
            name="postalAddress"
            label={sav_form.address.label}
            placeholder={sav_form.address.placeholder}
            isRequired={true}
            value={companyDetails?.address1 || purchaseShop?.ADRESSE1 || ""}
            onChange={(value) =>
              setCompanyDetails({
                ...companyDetails,
                address1: value,
              })
            }
          />
        </GridItem>

        <LimitedInput
          name="additionalAddress1"
          label={sav_form.additionalAddress.label}
          placeholder={sav_form.additionalAddress.placeholder}
          value={companyDetails?.address2 || purchaseShop?.ADRESSE2 || ""}
          onChange={(value) =>
            setCompanyDetails({
              ...companyDetails,
              address2: value,
            })
          }
        />

        <LimitedInput
          name="additionalAddress2"
          label={sav_form.additionalAddress2.label}
          placeholder={sav_form.additionalAddress2.placeholder}
          value={companyDetails?.address3 || purchaseShop?.ADRESSE3 || ""}
          onChange={(value) =>
            setCompanyDetails({
              ...companyDetails,
              address3: value,
            })
          }
        />

        <FormInput
          required
          type="text"
          name="postalCode"
          placeholder={sav_form.postal_code.placeholder}
          value={companyDetails?.postalCode || purchaseShop?.CODE_POSTAL || ""}
          onChange={(e) =>
            setCompanyDetails({
              ...companyDetails,
              postalCode: e.target.value,
            })
          }
        >
          {sav_form.postal_code.label}
        </FormInput>

        <FormInput
          required
          type="text"
          name="city"
          placeholder={sav_form.city.placeholder}
          value={companyDetails?.city || purchaseShop?.VILLE || ""}
          onChange={(e) =>
            setCompanyDetails({
              ...companyDetails,
              city: e.target.value,
            })
          }
        >
          {sav_form.city.label}
        </FormInput>

        <GridItem colSpan={2}>
          <FormInput
            type="email"
            name="email"
            required={true}
            placeholder={sav_form.email.placeholder}
            value={companyDetails?.email || purchaseShop?.EMAIL || ""}
            onChange={(e) =>
              setCompanyDetails({
                ...companyDetails,
                email: e.target.value,
              })
            }
          >
            {sav_form.email.label}
          </FormInput>
        </GridItem>

        <GridItem colSpan={2}>
          <FormInput
            required
            type="tel"
            name="phone"
            placeholder={sav_form.phone.placeholder}
            value={companyDetails?.phone || purchaseShop?.TELEPHONE || ""}
            onChange={(e) =>
              setCompanyDetails({
                ...companyDetails,
                phone: e.target.value,
              })
            }
          >
            {sav_form.phone.label}
          </FormInput>
        </GridItem>
      </Grid>
      <Divider mt={6} />
    </>
  );
}
